import { useEffect } from "react";

const NotFound = () => {
	useEffect(() => {
		window.location.reload();
	});
};

export default NotFound;
